import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table';
import Pagination from '../../../components/DatatablePagination';

export default (props) => {
    // console.log(props);
    const [state, setState] = useState({
        columns: [],
    });

    useEffect(() => {
        setState({
            ...state,
            columns: [
                {
                    columns: [
                        {
                            Header: 'Tên sản phẩm',
                            accessor: 'name',
                            minWidth: 150,
                        },
                        {
                            Header: 'Mã SKU',
                            accessor: 'sku',
                            minWidth: 150,
                        },
                        {
                            Header: 'Barcode',
                            accessor: 'barcode',
                            minWidth: 150,
                        },
                        {
                            Header: 'Loại sản phẩm',
                            accessor: 'category',
                            minWidth: 100,
                        },
                        {
                            Header: 'ID Loại sản phẩm',
                            accessor: 'category_id',
                            minWidth: 100,
                        },
                        {
                            Header: 'Khuyên dùng',
                            accessor: 'bester',
                            minWidth: 100,
                        },
                        {
                            Header: 'Giá bán',
                            accessor: 'price',
                            minWidth: 100,
                        },
                        {
                            Header: 'Giá khuyến mãi',
                            accessor: 'price_sale',
                            minWidth: 150,
                        },
                        {
                            Header: 'Active Sale',
                            accessor: 'active_sale',
                            minWidth: 100,
                        },
                        {
                            Header: 'Hình ảnh',
                            accessor: 'image',
                            minWidth: 260,
                        },
                    ],
                },
            ],
        });
    }, []);

    return (
        <ReactTable
            defaultPageSize={10}
            data={props.data}
            columns={state.columns}
            minRows={0}
            showPageJump={false}
            showPageSizeOptions={true}
            PaginationComponent={Pagination}
            NoDataComponent={() => null}
        />
    );
};
